function PageTitle({ children, textSizeClass }) {
    return (
        <div className={"comp__pageTitle sm:flex sm:justify-center md:justify-between sm:items-center"}>
            <h1 className={`${textSizeClass ? textSizeClass : "text-2xl md:text-3xl"} text-gray-800 dark:text-slate-100 font-bold flex gap-2 items-center`}>
                {children}
            </h1>
        </div>
    );
}

export default PageTitle;
